import React from 'react';
import AppShell from '../components/layout/AppShell';
import OpportunityFeed from '../features/opportunities/components/OpportunityFeed';

import { useAuth } from '../contexts/AuthContext';

/**
 * OpportunitiesPage — renders different views based on user role:
 *  - veterinarian → My Postings (manage their jobs)
 *  - student      → Browse all open opportunities
 */
const OpportunitiesPage = () => {
  const { user } = useAuth();
  const role = user?.role || 'student';

  return (
    <AppShell>
      <OpportunityFeed userRole={role} />
    </AppShell>
  );
};

export default OpportunitiesPage;
